/* eslint-disable */
// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,add_pb_suffix,ts_nocheck,eslint_disable
// @generated from protobuf file "accounting/models.proto" (package "rd.accounting", syntax proto3)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { InternalAccount } from "../coa/models_pb";
import { TimestampRange } from "../proto/timestamprange/models_pb";
import { Company } from "../company/models_pb";
import { Location } from "../company/models_pb";
import { User } from "../user/models_pb";
import { Timestamp } from "../google/protobuf/timestamp_pb";
import { UUID } from "../proto/uuid/models_pb";
import { Account } from "../coa/models_pb";
import { Decimal } from "../proto/decimal/models_pb";
import { Money } from "../proto/money/models_pb";
/**
 * IncomeStatement is the structured representation
 * of the income statement report
 *
 * @generated from protobuf message rd.accounting.IncomeStatement
 */
export interface IncomeStatement {
    /**
     * @generated from protobuf field: rd.proto.money.Money income_total = 1
     */
    incomeTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.IncomeStatement.AccountLineItem income_accounts = 2
     */
    incomeAccounts: IncomeStatement_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money cogs_total = 3
     */
    cogsTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.IncomeStatement.AccountLineItem cogs_accounts = 4
     */
    cogsAccounts: IncomeStatement_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money operating_expenses_total = 5
     */
    operatingExpensesTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.IncomeStatement.AccountLineItem operating_expenses_accounts = 6
     */
    operatingExpensesAccounts: IncomeStatement_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money gross_profit = 7
     */
    grossProfit?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal gross_profit_margin = 8
     */
    grossProfitMargin?: Decimal;
    /**
     * @generated from protobuf field: rd.proto.money.Money net_profit = 9
     */
    netProfit?: Money;
    /**
     * @generated from protobuf field: rd.proto.decimal.Decimal net_profit_margin = 10
     */
    netProfitMargin?: Decimal;
}
/**
 * @generated from protobuf message rd.accounting.IncomeStatement.AccountLineItem
 */
export interface IncomeStatement_AccountLineItem {
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 1
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.coa.Account account = 3
     */
    account?: Account;
}
/**
 * BalanceSheet is the structured representation
 * of the balance sheet report
 *
 * @generated from protobuf message rd.accounting.BalanceSheet
 */
export interface BalanceSheet {
    /**
     * @generated from protobuf field: rd.proto.money.Money asset_total = 1
     */
    assetTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.BalanceSheet.AccountLineItem asset_accounts = 2
     */
    assetAccounts: BalanceSheet_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money liability_total = 3
     */
    liabilityTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.BalanceSheet.AccountLineItem liability_accounts = 4
     */
    liabilityAccounts: BalanceSheet_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money equity_total = 5
     */
    equityTotal?: Money;
    /**
     * @generated from protobuf field: repeated rd.accounting.BalanceSheet.AccountLineItem equity_accounts = 6
     */
    equityAccounts: BalanceSheet_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money liability_and_equity_total = 7
     */
    liabilityAndEquityTotal?: Money;
}
/**
 * @generated from protobuf message rd.accounting.BalanceSheet.AccountLineItem
 */
export interface BalanceSheet_AccountLineItem {
    /**
     * @generated from protobuf field: rd.proto.money.Money total = 1
     */
    total?: Money;
    /**
     * @generated from protobuf field: rd.coa.Account account = 2
     */
    account?: Account;
}
/**
 * @generated from protobuf message rd.accounting.ExternalAccount
 */
export interface ExternalAccount {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID; // required
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID; // required
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 4
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 6
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deactivated_at = 7
     */
    deactivatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User deactivated_by = 8
     */
    deactivatedBy?: User;
    /**
     * @generated from protobuf field: bool is_active = 9
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: string identifier = 10
     */
    identifier: string; // required
    /**
     * @generated from protobuf field: string name = 11
     */
    name: string; // required
    /**
     * @generated from protobuf field: rd.accounting.ExternalAccount.Type type = 12
     */
    type: ExternalAccount_Type; // required
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID coa_account_id = 13
     */
    coaAccountId?: UUID; // required
    /**
     * @generated from protobuf field: string last_4 = 14
     */
    last4: string; // optional
}
/**
 * @generated from protobuf enum rd.accounting.ExternalAccount.Type
 */
export enum ExternalAccount_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_CHECKING = 1;
     */
    CHECKING = 1,
    /**
     * @generated from protobuf enum value: TYPE_SAVINGS = 2;
     */
    SAVINGS = 2,
    /**
     * @generated from protobuf enum value: TYPE_CREDIT_CARD = 3;
     */
    CREDIT_CARD = 3
}
/**
 * ExternalTransaction is a manually inputted transaction that occurrs outside
 * of Rundoo but is included for accounting purposes
 *
 * @generated from protobuf message rd.accounting.ExternalTransaction
 */
export interface ExternalTransaction {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 2
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 3
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 5
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User updated_by = 7
     */
    updatedBy?: User;
    /**
     * @generated from protobuf field: bool is_active = 8
     */
    isActive: boolean;
    /**
     * @generated from protobuf field: rd.proto.money.Money amount = 9
     */
    amount?: Money;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.Type type = 10
     */
    type: ExternalTransaction_Type;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp transacted_at = 11
     */
    transactedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction.PaymentMethod payment_method = 12
     */
    paymentMethod: ExternalTransaction_PaymentMethod;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID vendor_id = 13
     */
    vendorId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID customer_id = 14
     */
    customerId?: UUID;
    /**
     * @generated from protobuf field: string description = 16
     */
    description: string;
    /**
     * @generated from protobuf field: map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 17
     */
    allocationsByChartOfAccountId: {
        [key: string]: Money;
    };
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID external_account_id = 18
     */
    externalAccountId?: UUID;
    /**
     * @generated from protobuf field: string identifier = 19
     */
    identifier: string;
}
/**
 * @generated from protobuf enum rd.accounting.ExternalTransaction.Type
 */
export enum ExternalTransaction_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * (+ve) amount
     *
     * @generated from protobuf enum value: TYPE_DEPOSIT = 1;
     */
    DEPOSIT = 1,
    /**
     * (-ve) amount
     *
     * @generated from protobuf enum value: TYPE_PAYMENT = 2;
     */
    PAYMENT = 2
}
/**
 * @generated from protobuf enum rd.accounting.ExternalTransaction.PaymentMethod
 */
export enum ExternalTransaction_PaymentMethod {
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_BANK_CASH = 1;
     */
    BANK_CASH = 1,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_BANK_CHECK = 2;
     */
    BANK_CHECK = 2,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_BANK_CARD = 3;
     */
    BANK_CARD = 3,
    /**
     * @generated from protobuf enum value: PAYMENT_METHOD_BANK_TRANSFER = 4;
     */
    BANK_TRANSFER = 4
}
/**
 * @deprecated
 * @generated from protobuf message rd.accounting.ExternalTransactionLog
 */
export interface ExternalTransactionLog {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.user.User created_by = 3
     */
    createdBy?: User;
    /**
     * @generated from protobuf field: rd.accounting.ExternalTransaction external_transaction = 4
     */
    externalTransaction?: ExternalTransaction;
}
/**
 * JournalEntries is the structured representation of the journal
 * entries report generally used for exporting to accounting software
 *
 * @generated from protobuf message rd.accounting.JournalEntries
 */
export interface JournalEntries {
    /**
     * @generated from protobuf field: repeated rd.accounting.JournalEntries.AccountLineItem account_line_items = 1
     */
    accountLineItems: JournalEntries_AccountLineItem[];
    /**
     * @generated from protobuf field: rd.proto.money.Money debit_total = 2
     */
    debitTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit_total = 3
     */
    creditTotal?: Money;
}
/**
 * @generated from protobuf message rd.accounting.JournalEntries.AccountLineItem
 */
export interface JournalEntries_AccountLineItem {
    /**
     * @generated from protobuf field: rd.proto.money.Money debit = 1
     */
    debit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit = 2
     */
    credit?: Money;
    /**
     * @generated from protobuf field: rd.coa.Account account = 3
     */
    account?: Account;
}
/**
 * @generated from protobuf message rd.accounting.JournalEntriesPDFData
 */
export interface JournalEntriesPDFData {
    /**
     * @generated from protobuf field: repeated rd.accounting.JournalEntriesPDFData.AccountLineItem account_line_items = 1
     */
    accountLineItems: JournalEntriesPDFData_AccountLineItem[];
    /**
     * @generated from protobuf field: string debit_total = 2
     */
    debitTotal: string;
    /**
     * @generated from protobuf field: string credit_total = 3
     */
    creditTotal: string;
    /**
     * @generated from protobuf field: string timestamp_range = 4
     */
    timestampRange: string;
    /**
     * @generated from protobuf field: string location_name = 5
     */
    locationName: string;
    /**
     * @generated from protobuf field: rd.company.Location location = 6
     */
    location?: Location; // required by the header html template
    /**
     * @generated from protobuf field: rd.company.Company company = 7
     */
    company?: Company; // required by the header html template
}
/**
 * @generated from protobuf message rd.accounting.JournalEntriesPDFData.AccountLineItem
 */
export interface JournalEntriesPDFData_AccountLineItem {
    /**
     * @generated from protobuf field: string debit_amount = 1
     */
    debitAmount: string;
    /**
     * @generated from protobuf field: string credit_amount = 2
     */
    creditAmount: string;
    /**
     * @generated from protobuf field: rd.coa.Account account = 3
     */
    account?: Account;
}
/**
 * PayoutReconciliation is the structured representation
 * of the payout reconciliation report
 *
 * @generated from protobuf message rd.accounting.PayoutReconciliation
 */
export interface PayoutReconciliation {
}
/**
 * @generated from protobuf message rd.accounting.PayoutReconciliation.Transaction
 */
export interface PayoutReconciliation_Transaction {
}
/**
 * @generated from protobuf enum rd.accounting.PayoutReconciliation.Transaction.Type
 */
export enum PayoutReconciliation_Transaction_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0
}
/**
 * JournalEntry represents an accounting journal entry for a specific date.
 * The only expected mutation after creation is to set the exported date.
 *
 * @generated from protobuf message rd.accounting.JournalEntry
 */
export interface JournalEntry {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID id = 1
     */
    id?: UUID;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 2
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID company_id = 3
     */
    companyId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.timestamprange.TimestampRange timestamp_range = 4
     */
    timestampRange?: TimestampRange;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp exported_at = 5
     */
    exportedAt?: Timestamp;
    /**
     * @generated from protobuf field: rd.proto.money.Money debit_total = 6
     */
    debitTotal?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit_total = 7
     */
    creditTotal?: Money;
    /**
     * @generated from protobuf field: bool is_auto_generated = 8
     */
    isAutoGenerated: boolean;
    /**
     * @generated from protobuf field: repeated string quickbooks_online_urls = 9
     */
    quickbooksOnlineUrls: string[];
    /**
     * @generated from protobuf field: string time_zone = 10
     */
    timeZone: string;
    /**
     * @generated from protobuf field: rd.accounting.JournalEntry.Type type = 11
     */
    type: JournalEntry_Type;
    /**
     * @generated from protobuf field: repeated rd.accounting.JournalEntry.SalesLine sales_lines = 12
     */
    salesLines: JournalEntry_SalesLine[];
    /**
     * @generated from protobuf field: repeated rd.accounting.JournalEntry.PurchaseLine purchase_lines = 13
     */
    purchaseLines: JournalEntry_PurchaseLine[];
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 14
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: string order_identifier = 15
     */
    orderIdentifier: string;
    /**
     * @generated from protobuf field: bool is_archived = 16
     */
    isArchived: boolean;
    /**
     * @generated from protobuf field: rd.user.User archived_by = 17
     */
    archivedBy?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp archived_at = 18
     */
    archivedAt?: Timestamp;
}
/**
 * @generated from protobuf message rd.accounting.JournalEntry.SalesLine
 */
export interface JournalEntry_SalesLine {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 1
     */
    accountId?: UUID;
    /**
     * @generated from protobuf field: int32 account_number = 2
     */
    accountNumber: number;
    /**
     * @generated from protobuf field: string account_name = 3
     */
    accountName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money debit = 4
     */
    debit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit = 5
     */
    credit?: Money;
    /**
     * @generated from protobuf field: string class = 6
     */
    class: string;
    /**
     * @generated from protobuf field: string customer = 7
     */
    customer: string;
    /**
     * @generated from protobuf field: string vendor = 8
     */
    vendor: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 9
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 10
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount internal_accounts = 11
     */
    internalAccounts: InternalAccount[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 12
     */
    methodIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_ids = 13
     */
    additionalFeeIds: string[];
}
/**
 * @generated from protobuf message rd.accounting.JournalEntry.PurchaseLine
 */
export interface JournalEntry_PurchaseLine {
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID account_id = 1
     */
    accountId?: UUID;
    /**
     * @generated from protobuf field: int32 account_number = 2
     */
    accountNumber: number;
    /**
     * @generated from protobuf field: string account_name = 3
     */
    accountName: string;
    /**
     * @generated from protobuf field: rd.proto.money.Money debit = 4
     */
    debit?: Money;
    /**
     * @generated from protobuf field: rd.proto.money.Money credit = 5
     */
    credit?: Money;
    /**
     * @generated from protobuf field: string class = 6
     */
    class: string;
    /**
     * @generated from protobuf field: string pay_to = 7
     */
    payTo: string;
    /**
     * @generated from protobuf field: string vendor = 8
     */
    vendor: string;
    /**
     * @generated from protobuf field: string invoice_number = 9
     */
    invoiceNumber: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp invoice_date = 10
     */
    invoiceDate?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp due_date = 11
     */
    dueDate?: Timestamp;
    /**
     * @generated from protobuf field: string order_identifier = 12
     */
    orderIdentifier: string;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID order_shipment_id = 13
     */
    orderShipmentId?: UUID;
    /**
     * @generated from protobuf field: rd.proto.uuid.UUID location_id = 14
     */
    locationId?: UUID;
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID department_ids = 15
     */
    departmentIds: UUID[];
    /**
     * @generated from protobuf field: repeated rd.coa.InternalAccount internal_accounts = 16
     */
    internalAccounts: InternalAccount[];
    /**
     * @generated from protobuf field: repeated rd.proto.uuid.UUID method_ids = 17
     */
    methodIds: UUID[];
    /**
     * @generated from protobuf field: repeated string additional_fee_ids = 18
     */
    additionalFeeIds: string[];
}
/**
 * @generated from protobuf enum rd.accounting.JournalEntry.Type
 */
export enum JournalEntry_Type {
    /**
     * @generated from protobuf enum value: TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TYPE_SALES = 1;
     */
    SALES = 1,
    /**
     * @generated from protobuf enum value: TYPE_PURCHASE = 2;
     */
    PURCHASE = 2
}
/**
 * @generated from protobuf enum rd.accounting.GeneralLedgerSortBy
 */
export enum GeneralLedgerSortBy {
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_DATE = 1;
     */
    DATE = 1,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_ACCOUNT_NUMBER = 2;
     */
    ACCOUNT_NUMBER = 2,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_ACCOUNT_NAME = 3;
     */
    ACCOUNT_NAME = 3,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_LOCATION_ID = 4;
     */
    LOCATION_ID = 4,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_DEBIT = 5;
     */
    DEBIT = 5,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_CREDIT = 6;
     */
    CREDIT = 6,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_TRANSACTION_ID = 7;
     */
    TRANSACTION_ID = 7,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_CUSTOMER_ID = 8;
     */
    CUSTOMER_ID = 8,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_CONTROL_ACCOUNT = 9;
     */
    CONTROL_ACCOUNT = 9,
    /**
     * @generated from protobuf enum value: GENERAL_LEDGER_SORT_BY_DEPARTMENT = 10;
     */
    DEPARTMENT = 10
}
/**
 * @generated from protobuf enum rd.accounting.TransactionType
 */
export enum TransactionType {
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_UNDEFINED = 0;
     */
    UNDEFINED = 0,
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_INTERNAL = 1;
     */
    INTERNAL = 1,
    /**
     * @generated from protobuf enum value: TRANSACTION_TYPE_EXTERNAL = 2;
     */
    EXTERNAL = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class IncomeStatement$Type extends MessageType<IncomeStatement> {
    constructor() {
        super("rd.accounting.IncomeStatement", [
            { no: 1, name: "income_total", kind: "message", T: () => Money },
            { no: 2, name: "income_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IncomeStatement_AccountLineItem },
            { no: 3, name: "cogs_total", kind: "message", T: () => Money },
            { no: 4, name: "cogs_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IncomeStatement_AccountLineItem },
            { no: 5, name: "operating_expenses_total", kind: "message", T: () => Money },
            { no: 6, name: "operating_expenses_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => IncomeStatement_AccountLineItem },
            { no: 7, name: "gross_profit", kind: "message", T: () => Money },
            { no: 8, name: "gross_profit_margin", kind: "message", T: () => Decimal },
            { no: 9, name: "net_profit", kind: "message", T: () => Money },
            { no: 10, name: "net_profit_margin", kind: "message", T: () => Decimal }
        ]);
    }
    create(value?: PartialMessage<IncomeStatement>): IncomeStatement {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.incomeAccounts = [];
        message.cogsAccounts = [];
        message.operatingExpensesAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<IncomeStatement>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncomeStatement): IncomeStatement {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money income_total */ 1:
                    message.incomeTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.incomeTotal);
                    break;
                case /* repeated rd.accounting.IncomeStatement.AccountLineItem income_accounts */ 2:
                    message.incomeAccounts.push(IncomeStatement_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money cogs_total */ 3:
                    message.cogsTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.cogsTotal);
                    break;
                case /* repeated rd.accounting.IncomeStatement.AccountLineItem cogs_accounts */ 4:
                    message.cogsAccounts.push(IncomeStatement_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money operating_expenses_total */ 5:
                    message.operatingExpensesTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.operatingExpensesTotal);
                    break;
                case /* repeated rd.accounting.IncomeStatement.AccountLineItem operating_expenses_accounts */ 6:
                    message.operatingExpensesAccounts.push(IncomeStatement_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money gross_profit */ 7:
                    message.grossProfit = Money.internalBinaryRead(reader, reader.uint32(), options, message.grossProfit);
                    break;
                case /* rd.proto.decimal.Decimal gross_profit_margin */ 8:
                    message.grossProfitMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.grossProfitMargin);
                    break;
                case /* rd.proto.money.Money net_profit */ 9:
                    message.netProfit = Money.internalBinaryRead(reader, reader.uint32(), options, message.netProfit);
                    break;
                case /* rd.proto.decimal.Decimal net_profit_margin */ 10:
                    message.netProfitMargin = Decimal.internalBinaryRead(reader, reader.uint32(), options, message.netProfitMargin);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncomeStatement, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money income_total = 1; */
        if (message.incomeTotal)
            Money.internalBinaryWrite(message.incomeTotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.IncomeStatement.AccountLineItem income_accounts = 2; */
        for (let i = 0; i < message.incomeAccounts.length; i++)
            IncomeStatement_AccountLineItem.internalBinaryWrite(message.incomeAccounts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money cogs_total = 3; */
        if (message.cogsTotal)
            Money.internalBinaryWrite(message.cogsTotal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.IncomeStatement.AccountLineItem cogs_accounts = 4; */
        for (let i = 0; i < message.cogsAccounts.length; i++)
            IncomeStatement_AccountLineItem.internalBinaryWrite(message.cogsAccounts[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money operating_expenses_total = 5; */
        if (message.operatingExpensesTotal)
            Money.internalBinaryWrite(message.operatingExpensesTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.IncomeStatement.AccountLineItem operating_expenses_accounts = 6; */
        for (let i = 0; i < message.operatingExpensesAccounts.length; i++)
            IncomeStatement_AccountLineItem.internalBinaryWrite(message.operatingExpensesAccounts[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money gross_profit = 7; */
        if (message.grossProfit)
            Money.internalBinaryWrite(message.grossProfit, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal gross_profit_margin = 8; */
        if (message.grossProfitMargin)
            Decimal.internalBinaryWrite(message.grossProfitMargin, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money net_profit = 9; */
        if (message.netProfit)
            Money.internalBinaryWrite(message.netProfit, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.decimal.Decimal net_profit_margin = 10; */
        if (message.netProfitMargin)
            Decimal.internalBinaryWrite(message.netProfitMargin, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.IncomeStatement
 */
export const IncomeStatement = new IncomeStatement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class IncomeStatement_AccountLineItem$Type extends MessageType<IncomeStatement_AccountLineItem> {
    constructor() {
        super("rd.accounting.IncomeStatement.AccountLineItem", [
            { no: 1, name: "total", kind: "message", T: () => Money },
            { no: 3, name: "account", kind: "message", T: () => Account }
        ]);
    }
    create(value?: PartialMessage<IncomeStatement_AccountLineItem>): IncomeStatement_AccountLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<IncomeStatement_AccountLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: IncomeStatement_AccountLineItem): IncomeStatement_AccountLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money total */ 1:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.coa.Account account */ 3:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: IncomeStatement_AccountLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money total = 1; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account account = 3; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.IncomeStatement.AccountLineItem
 */
export const IncomeStatement_AccountLineItem = new IncomeStatement_AccountLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BalanceSheet$Type extends MessageType<BalanceSheet> {
    constructor() {
        super("rd.accounting.BalanceSheet", [
            { no: 1, name: "asset_total", kind: "message", T: () => Money },
            { no: 2, name: "asset_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BalanceSheet_AccountLineItem },
            { no: 3, name: "liability_total", kind: "message", T: () => Money },
            { no: 4, name: "liability_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BalanceSheet_AccountLineItem },
            { no: 5, name: "equity_total", kind: "message", T: () => Money },
            { no: 6, name: "equity_accounts", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BalanceSheet_AccountLineItem },
            { no: 7, name: "liability_and_equity_total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<BalanceSheet>): BalanceSheet {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.assetAccounts = [];
        message.liabilityAccounts = [];
        message.equityAccounts = [];
        if (value !== undefined)
            reflectionMergePartial<BalanceSheet>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BalanceSheet): BalanceSheet {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money asset_total */ 1:
                    message.assetTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.assetTotal);
                    break;
                case /* repeated rd.accounting.BalanceSheet.AccountLineItem asset_accounts */ 2:
                    message.assetAccounts.push(BalanceSheet_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money liability_total */ 3:
                    message.liabilityTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.liabilityTotal);
                    break;
                case /* repeated rd.accounting.BalanceSheet.AccountLineItem liability_accounts */ 4:
                    message.liabilityAccounts.push(BalanceSheet_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money equity_total */ 5:
                    message.equityTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.equityTotal);
                    break;
                case /* repeated rd.accounting.BalanceSheet.AccountLineItem equity_accounts */ 6:
                    message.equityAccounts.push(BalanceSheet_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money liability_and_equity_total */ 7:
                    message.liabilityAndEquityTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.liabilityAndEquityTotal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BalanceSheet, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money asset_total = 1; */
        if (message.assetTotal)
            Money.internalBinaryWrite(message.assetTotal, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.BalanceSheet.AccountLineItem asset_accounts = 2; */
        for (let i = 0; i < message.assetAccounts.length; i++)
            BalanceSheet_AccountLineItem.internalBinaryWrite(message.assetAccounts[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money liability_total = 3; */
        if (message.liabilityTotal)
            Money.internalBinaryWrite(message.liabilityTotal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.BalanceSheet.AccountLineItem liability_accounts = 4; */
        for (let i = 0; i < message.liabilityAccounts.length; i++)
            BalanceSheet_AccountLineItem.internalBinaryWrite(message.liabilityAccounts[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money equity_total = 5; */
        if (message.equityTotal)
            Money.internalBinaryWrite(message.equityTotal, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.BalanceSheet.AccountLineItem equity_accounts = 6; */
        for (let i = 0; i < message.equityAccounts.length; i++)
            BalanceSheet_AccountLineItem.internalBinaryWrite(message.equityAccounts[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money liability_and_equity_total = 7; */
        if (message.liabilityAndEquityTotal)
            Money.internalBinaryWrite(message.liabilityAndEquityTotal, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.BalanceSheet
 */
export const BalanceSheet = new BalanceSheet$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BalanceSheet_AccountLineItem$Type extends MessageType<BalanceSheet_AccountLineItem> {
    constructor() {
        super("rd.accounting.BalanceSheet.AccountLineItem", [
            { no: 1, name: "total", kind: "message", T: () => Money },
            { no: 2, name: "account", kind: "message", T: () => Account }
        ]);
    }
    create(value?: PartialMessage<BalanceSheet_AccountLineItem>): BalanceSheet_AccountLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<BalanceSheet_AccountLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BalanceSheet_AccountLineItem): BalanceSheet_AccountLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money total */ 1:
                    message.total = Money.internalBinaryRead(reader, reader.uint32(), options, message.total);
                    break;
                case /* rd.coa.Account account */ 2:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BalanceSheet_AccountLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money total = 1; */
        if (message.total)
            Money.internalBinaryWrite(message.total, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account account = 2; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.BalanceSheet.AccountLineItem
 */
export const BalanceSheet_AccountLineItem = new BalanceSheet_AccountLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalAccount$Type extends MessageType<ExternalAccount> {
    constructor() {
        super("rd.accounting.ExternalAccount", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "created_by", kind: "message", T: () => User },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "updated_by", kind: "message", T: () => User },
            { no: 7, name: "deactivated_at", kind: "message", T: () => Timestamp },
            { no: 8, name: "deactivated_by", kind: "message", T: () => User },
            { no: 9, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "type", kind: "enum", T: () => ["rd.accounting.ExternalAccount.Type", ExternalAccount_Type, "TYPE_"] },
            { no: 13, name: "coa_account_id", kind: "message", T: () => UUID },
            { no: 14, name: "last_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalAccount>): ExternalAccount {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActive = false;
        message.identifier = "";
        message.name = "";
        message.type = 0;
        message.last4 = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalAccount>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalAccount): ExternalAccount {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 3:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 4:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 5:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 6:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* google.protobuf.Timestamp deactivated_at */ 7:
                    message.deactivatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deactivatedAt);
                    break;
                case /* rd.user.User deactivated_by */ 8:
                    message.deactivatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.deactivatedBy);
                    break;
                case /* bool is_active */ 9:
                    message.isActive = reader.bool();
                    break;
                case /* string identifier */ 10:
                    message.identifier = reader.string();
                    break;
                case /* string name */ 11:
                    message.name = reader.string();
                    break;
                case /* rd.accounting.ExternalAccount.Type type */ 12:
                    message.type = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID coa_account_id */ 13:
                    message.coaAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.coaAccountId);
                    break;
                case /* string last_4 */ 14:
                    message.last4 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalAccount, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 3; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 4; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 5; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 6; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deactivated_at = 7; */
        if (message.deactivatedAt)
            Timestamp.internalBinaryWrite(message.deactivatedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User deactivated_by = 8; */
        if (message.deactivatedBy)
            User.internalBinaryWrite(message.deactivatedBy, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 9; */
        if (message.isActive !== false)
            writer.tag(9, WireType.Varint).bool(message.isActive);
        /* string identifier = 10; */
        if (message.identifier !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.identifier);
        /* string name = 11; */
        if (message.name !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.name);
        /* rd.accounting.ExternalAccount.Type type = 12; */
        if (message.type !== 0)
            writer.tag(12, WireType.Varint).int32(message.type);
        /* rd.proto.uuid.UUID coa_account_id = 13; */
        if (message.coaAccountId)
            UUID.internalBinaryWrite(message.coaAccountId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* string last_4 = 14; */
        if (message.last4 !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.last4);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.ExternalAccount
 */
export const ExternalAccount = new ExternalAccount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTransaction$Type extends MessageType<ExternalTransaction> {
    constructor() {
        super("rd.accounting.ExternalTransaction", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "company_id", kind: "message", T: () => UUID },
            { no: 3, name: "location_id", kind: "message", T: () => UUID },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 5, name: "created_by", kind: "message", T: () => User },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 7, name: "updated_by", kind: "message", T: () => User },
            { no: 8, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "amount", kind: "message", T: () => Money },
            { no: 10, name: "type", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.Type", ExternalTransaction_Type, "TYPE_"] },
            { no: 11, name: "transacted_at", kind: "message", T: () => Timestamp },
            { no: 12, name: "payment_method", kind: "enum", T: () => ["rd.accounting.ExternalTransaction.PaymentMethod", ExternalTransaction_PaymentMethod, "PAYMENT_METHOD_"] },
            { no: 13, name: "vendor_id", kind: "message", T: () => UUID },
            { no: 14, name: "customer_id", kind: "message", T: () => UUID },
            { no: 16, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "allocations_by_chart_of_account_id", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => Money } },
            { no: 18, name: "external_account_id", kind: "message", T: () => UUID },
            { no: 19, name: "identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<ExternalTransaction>): ExternalTransaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isActive = false;
        message.type = 0;
        message.paymentMethod = 0;
        message.description = "";
        message.allocationsByChartOfAccountId = {};
        message.identifier = "";
        if (value !== undefined)
            reflectionMergePartial<ExternalTransaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTransaction): ExternalTransaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 2:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 3:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 5:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* rd.user.User updated_by */ 7:
                    message.updatedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.updatedBy);
                    break;
                case /* bool is_active */ 8:
                    message.isActive = reader.bool();
                    break;
                case /* rd.proto.money.Money amount */ 9:
                    message.amount = Money.internalBinaryRead(reader, reader.uint32(), options, message.amount);
                    break;
                case /* rd.accounting.ExternalTransaction.Type type */ 10:
                    message.type = reader.int32();
                    break;
                case /* google.protobuf.Timestamp transacted_at */ 11:
                    message.transactedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.transactedAt);
                    break;
                case /* rd.accounting.ExternalTransaction.PaymentMethod payment_method */ 12:
                    message.paymentMethod = reader.int32();
                    break;
                case /* rd.proto.uuid.UUID vendor_id */ 13:
                    message.vendorId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.vendorId);
                    break;
                case /* rd.proto.uuid.UUID customer_id */ 14:
                    message.customerId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.customerId);
                    break;
                case /* string description */ 16:
                    message.description = reader.string();
                    break;
                case /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id */ 17:
                    this.binaryReadMap17(message.allocationsByChartOfAccountId, reader, options);
                    break;
                case /* rd.proto.uuid.UUID external_account_id */ 18:
                    message.externalAccountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.externalAccountId);
                    break;
                case /* string identifier */ 19:
                    message.identifier = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap17(map: ExternalTransaction["allocationsByChartOfAccountId"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof ExternalTransaction["allocationsByChartOfAccountId"] | undefined, val: ExternalTransaction["allocationsByChartOfAccountId"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = Money.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for rd.accounting.ExternalTransaction.allocations_by_chart_of_account_id");
            }
        }
        map[key ?? ""] = val ?? Money.create();
    }
    internalBinaryWrite(message: ExternalTransaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 2; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 3; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 5; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User updated_by = 7; */
        if (message.updatedBy)
            User.internalBinaryWrite(message.updatedBy, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_active = 8; */
        if (message.isActive !== false)
            writer.tag(8, WireType.Varint).bool(message.isActive);
        /* rd.proto.money.Money amount = 9; */
        if (message.amount)
            Money.internalBinaryWrite(message.amount, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction.Type type = 10; */
        if (message.type !== 0)
            writer.tag(10, WireType.Varint).int32(message.type);
        /* google.protobuf.Timestamp transacted_at = 11; */
        if (message.transactedAt)
            Timestamp.internalBinaryWrite(message.transactedAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction.PaymentMethod payment_method = 12; */
        if (message.paymentMethod !== 0)
            writer.tag(12, WireType.Varint).int32(message.paymentMethod);
        /* rd.proto.uuid.UUID vendor_id = 13; */
        if (message.vendorId)
            UUID.internalBinaryWrite(message.vendorId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID customer_id = 14; */
        if (message.customerId)
            UUID.internalBinaryWrite(message.customerId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string description = 16; */
        if (message.description !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.description);
        /* map<string, rd.proto.money.Money> allocations_by_chart_of_account_id = 17; */
        for (let k of globalThis.Object.keys(message.allocationsByChartOfAccountId)) {
            writer.tag(17, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            Money.internalBinaryWrite(message.allocationsByChartOfAccountId[k], writer, options);
            writer.join().join();
        }
        /* rd.proto.uuid.UUID external_account_id = 18; */
        if (message.externalAccountId)
            UUID.internalBinaryWrite(message.externalAccountId, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        /* string identifier = 19; */
        if (message.identifier !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.identifier);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.ExternalTransaction
 */
export const ExternalTransaction = new ExternalTransaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ExternalTransactionLog$Type extends MessageType<ExternalTransactionLog> {
    constructor() {
        super("rd.accounting.ExternalTransactionLog", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "created_by", kind: "message", T: () => User },
            { no: 4, name: "external_transaction", kind: "message", T: () => ExternalTransaction }
        ]);
    }
    create(value?: PartialMessage<ExternalTransactionLog>): ExternalTransactionLog {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ExternalTransactionLog>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ExternalTransactionLog): ExternalTransactionLog {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.user.User created_by */ 3:
                    message.createdBy = User.internalBinaryRead(reader, reader.uint32(), options, message.createdBy);
                    break;
                case /* rd.accounting.ExternalTransaction external_transaction */ 4:
                    message.externalTransaction = ExternalTransaction.internalBinaryRead(reader, reader.uint32(), options, message.externalTransaction);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ExternalTransactionLog, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.user.User created_by = 3; */
        if (message.createdBy)
            User.internalBinaryWrite(message.createdBy, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.accounting.ExternalTransaction external_transaction = 4; */
        if (message.externalTransaction)
            ExternalTransaction.internalBinaryWrite(message.externalTransaction, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @deprecated
 * @generated MessageType for protobuf message rd.accounting.ExternalTransactionLog
 */
export const ExternalTransactionLog = new ExternalTransactionLog$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntries$Type extends MessageType<JournalEntries> {
    constructor() {
        super("rd.accounting.JournalEntries", [
            { no: 1, name: "account_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JournalEntries_AccountLineItem },
            { no: 2, name: "debit_total", kind: "message", T: () => Money },
            { no: 3, name: "credit_total", kind: "message", T: () => Money }
        ]);
    }
    create(value?: PartialMessage<JournalEntries>): JournalEntries {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountLineItems = [];
        if (value !== undefined)
            reflectionMergePartial<JournalEntries>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntries): JournalEntries {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.accounting.JournalEntries.AccountLineItem account_line_items */ 1:
                    message.accountLineItems.push(JournalEntries_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.money.Money debit_total */ 2:
                    message.debitTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.debitTotal);
                    break;
                case /* rd.proto.money.Money credit_total */ 3:
                    message.creditTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.creditTotal);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntries, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.accounting.JournalEntries.AccountLineItem account_line_items = 1; */
        for (let i = 0; i < message.accountLineItems.length; i++)
            JournalEntries_AccountLineItem.internalBinaryWrite(message.accountLineItems[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money debit_total = 2; */
        if (message.debitTotal)
            Money.internalBinaryWrite(message.debitTotal, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit_total = 3; */
        if (message.creditTotal)
            Money.internalBinaryWrite(message.creditTotal, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntries
 */
export const JournalEntries = new JournalEntries$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntries_AccountLineItem$Type extends MessageType<JournalEntries_AccountLineItem> {
    constructor() {
        super("rd.accounting.JournalEntries.AccountLineItem", [
            { no: 1, name: "debit", kind: "message", T: () => Money },
            { no: 2, name: "credit", kind: "message", T: () => Money },
            { no: 3, name: "account", kind: "message", T: () => Account }
        ]);
    }
    create(value?: PartialMessage<JournalEntries_AccountLineItem>): JournalEntries_AccountLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<JournalEntries_AccountLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntries_AccountLineItem): JournalEntries_AccountLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.money.Money debit */ 1:
                    message.debit = Money.internalBinaryRead(reader, reader.uint32(), options, message.debit);
                    break;
                case /* rd.proto.money.Money credit */ 2:
                    message.credit = Money.internalBinaryRead(reader, reader.uint32(), options, message.credit);
                    break;
                case /* rd.coa.Account account */ 3:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntries_AccountLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.money.Money debit = 1; */
        if (message.debit)
            Money.internalBinaryWrite(message.debit, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit = 2; */
        if (message.credit)
            Money.internalBinaryWrite(message.credit, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.coa.Account account = 3; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntries.AccountLineItem
 */
export const JournalEntries_AccountLineItem = new JournalEntries_AccountLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntriesPDFData$Type extends MessageType<JournalEntriesPDFData> {
    constructor() {
        super("rd.accounting.JournalEntriesPDFData", [
            { no: 1, name: "account_line_items", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JournalEntriesPDFData_AccountLineItem },
            { no: 2, name: "debit_total", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "credit_total", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "timestamp_range", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "location_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "location", kind: "message", T: () => Location },
            { no: 7, name: "company", kind: "message", T: () => Company }
        ]);
    }
    create(value?: PartialMessage<JournalEntriesPDFData>): JournalEntriesPDFData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountLineItems = [];
        message.debitTotal = "";
        message.creditTotal = "";
        message.timestampRange = "";
        message.locationName = "";
        if (value !== undefined)
            reflectionMergePartial<JournalEntriesPDFData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntriesPDFData): JournalEntriesPDFData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated rd.accounting.JournalEntriesPDFData.AccountLineItem account_line_items */ 1:
                    message.accountLineItems.push(JournalEntriesPDFData_AccountLineItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string debit_total */ 2:
                    message.debitTotal = reader.string();
                    break;
                case /* string credit_total */ 3:
                    message.creditTotal = reader.string();
                    break;
                case /* string timestamp_range */ 4:
                    message.timestampRange = reader.string();
                    break;
                case /* string location_name */ 5:
                    message.locationName = reader.string();
                    break;
                case /* rd.company.Location location */ 6:
                    message.location = Location.internalBinaryRead(reader, reader.uint32(), options, message.location);
                    break;
                case /* rd.company.Company company */ 7:
                    message.company = Company.internalBinaryRead(reader, reader.uint32(), options, message.company);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntriesPDFData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated rd.accounting.JournalEntriesPDFData.AccountLineItem account_line_items = 1; */
        for (let i = 0; i < message.accountLineItems.length; i++)
            JournalEntriesPDFData_AccountLineItem.internalBinaryWrite(message.accountLineItems[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string debit_total = 2; */
        if (message.debitTotal !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.debitTotal);
        /* string credit_total = 3; */
        if (message.creditTotal !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.creditTotal);
        /* string timestamp_range = 4; */
        if (message.timestampRange !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.timestampRange);
        /* string location_name = 5; */
        if (message.locationName !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.locationName);
        /* rd.company.Location location = 6; */
        if (message.location)
            Location.internalBinaryWrite(message.location, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.company.Company company = 7; */
        if (message.company)
            Company.internalBinaryWrite(message.company, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntriesPDFData
 */
export const JournalEntriesPDFData = new JournalEntriesPDFData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntriesPDFData_AccountLineItem$Type extends MessageType<JournalEntriesPDFData_AccountLineItem> {
    constructor() {
        super("rd.accounting.JournalEntriesPDFData.AccountLineItem", [
            { no: 1, name: "debit_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "credit_amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "account", kind: "message", T: () => Account }
        ]);
    }
    create(value?: PartialMessage<JournalEntriesPDFData_AccountLineItem>): JournalEntriesPDFData_AccountLineItem {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.debitAmount = "";
        message.creditAmount = "";
        if (value !== undefined)
            reflectionMergePartial<JournalEntriesPDFData_AccountLineItem>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntriesPDFData_AccountLineItem): JournalEntriesPDFData_AccountLineItem {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string debit_amount */ 1:
                    message.debitAmount = reader.string();
                    break;
                case /* string credit_amount */ 2:
                    message.creditAmount = reader.string();
                    break;
                case /* rd.coa.Account account */ 3:
                    message.account = Account.internalBinaryRead(reader, reader.uint32(), options, message.account);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntriesPDFData_AccountLineItem, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string debit_amount = 1; */
        if (message.debitAmount !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.debitAmount);
        /* string credit_amount = 2; */
        if (message.creditAmount !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.creditAmount);
        /* rd.coa.Account account = 3; */
        if (message.account)
            Account.internalBinaryWrite(message.account, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntriesPDFData.AccountLineItem
 */
export const JournalEntriesPDFData_AccountLineItem = new JournalEntriesPDFData_AccountLineItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PayoutReconciliation$Type extends MessageType<PayoutReconciliation> {
    constructor() {
        super("rd.accounting.PayoutReconciliation", []);
    }
    create(value?: PartialMessage<PayoutReconciliation>): PayoutReconciliation {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PayoutReconciliation>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PayoutReconciliation): PayoutReconciliation {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PayoutReconciliation, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.PayoutReconciliation
 */
export const PayoutReconciliation = new PayoutReconciliation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PayoutReconciliation_Transaction$Type extends MessageType<PayoutReconciliation_Transaction> {
    constructor() {
        super("rd.accounting.PayoutReconciliation.Transaction", []);
    }
    create(value?: PartialMessage<PayoutReconciliation_Transaction>): PayoutReconciliation_Transaction {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PayoutReconciliation_Transaction>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PayoutReconciliation_Transaction): PayoutReconciliation_Transaction {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PayoutReconciliation_Transaction, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.PayoutReconciliation.Transaction
 */
export const PayoutReconciliation_Transaction = new PayoutReconciliation_Transaction$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntry$Type extends MessageType<JournalEntry> {
    constructor() {
        super("rd.accounting.JournalEntry", [
            { no: 1, name: "id", kind: "message", T: () => UUID },
            { no: 2, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "company_id", kind: "message", T: () => UUID },
            { no: 4, name: "timestamp_range", kind: "message", T: () => TimestampRange },
            { no: 5, name: "exported_at", kind: "message", T: () => Timestamp },
            { no: 6, name: "debit_total", kind: "message", T: () => Money },
            { no: 7, name: "credit_total", kind: "message", T: () => Money },
            { no: 8, name: "is_auto_generated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "quickbooks_online_urls", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "time_zone", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "type", kind: "enum", T: () => ["rd.accounting.JournalEntry.Type", JournalEntry_Type, "TYPE_"] },
            { no: 12, name: "sales_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JournalEntry_SalesLine },
            { no: 13, name: "purchase_lines", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JournalEntry_PurchaseLine },
            { no: 14, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 15, name: "order_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "is_archived", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "archived_by", kind: "message", T: () => User },
            { no: 18, name: "archived_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<JournalEntry>): JournalEntry {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isAutoGenerated = false;
        message.quickbooksOnlineUrls = [];
        message.timeZone = "";
        message.type = 0;
        message.salesLines = [];
        message.purchaseLines = [];
        message.orderIdentifier = "";
        message.isArchived = false;
        if (value !== undefined)
            reflectionMergePartial<JournalEntry>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntry): JournalEntry {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID id */ 1:
                    message.id = UUID.internalBinaryRead(reader, reader.uint32(), options, message.id);
                    break;
                case /* google.protobuf.Timestamp created_at */ 2:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* rd.proto.uuid.UUID company_id */ 3:
                    message.companyId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.companyId);
                    break;
                case /* rd.proto.timestamprange.TimestampRange timestamp_range */ 4:
                    message.timestampRange = TimestampRange.internalBinaryRead(reader, reader.uint32(), options, message.timestampRange);
                    break;
                case /* google.protobuf.Timestamp exported_at */ 5:
                    message.exportedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.exportedAt);
                    break;
                case /* rd.proto.money.Money debit_total */ 6:
                    message.debitTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.debitTotal);
                    break;
                case /* rd.proto.money.Money credit_total */ 7:
                    message.creditTotal = Money.internalBinaryRead(reader, reader.uint32(), options, message.creditTotal);
                    break;
                case /* bool is_auto_generated */ 8:
                    message.isAutoGenerated = reader.bool();
                    break;
                case /* repeated string quickbooks_online_urls */ 9:
                    message.quickbooksOnlineUrls.push(reader.string());
                    break;
                case /* string time_zone */ 10:
                    message.timeZone = reader.string();
                    break;
                case /* rd.accounting.JournalEntry.Type type */ 11:
                    message.type = reader.int32();
                    break;
                case /* repeated rd.accounting.JournalEntry.SalesLine sales_lines */ 12:
                    message.salesLines.push(JournalEntry_SalesLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.accounting.JournalEntry.PurchaseLine purchase_lines */ 13:
                    message.purchaseLines.push(JournalEntry_PurchaseLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 14:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* string order_identifier */ 15:
                    message.orderIdentifier = reader.string();
                    break;
                case /* bool is_archived */ 16:
                    message.isArchived = reader.bool();
                    break;
                case /* rd.user.User archived_by */ 17:
                    message.archivedBy = User.internalBinaryRead(reader, reader.uint32(), options, message.archivedBy);
                    break;
                case /* google.protobuf.Timestamp archived_at */ 18:
                    message.archivedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.archivedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntry, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID id = 1; */
        if (message.id)
            UUID.internalBinaryWrite(message.id, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp created_at = 2; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID company_id = 3; */
        if (message.companyId)
            UUID.internalBinaryWrite(message.companyId, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.timestamprange.TimestampRange timestamp_range = 4; */
        if (message.timestampRange)
            TimestampRange.internalBinaryWrite(message.timestampRange, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp exported_at = 5; */
        if (message.exportedAt)
            Timestamp.internalBinaryWrite(message.exportedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money debit_total = 6; */
        if (message.debitTotal)
            Money.internalBinaryWrite(message.debitTotal, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit_total = 7; */
        if (message.creditTotal)
            Money.internalBinaryWrite(message.creditTotal, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* bool is_auto_generated = 8; */
        if (message.isAutoGenerated !== false)
            writer.tag(8, WireType.Varint).bool(message.isAutoGenerated);
        /* repeated string quickbooks_online_urls = 9; */
        for (let i = 0; i < message.quickbooksOnlineUrls.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.quickbooksOnlineUrls[i]);
        /* string time_zone = 10; */
        if (message.timeZone !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timeZone);
        /* rd.accounting.JournalEntry.Type type = 11; */
        if (message.type !== 0)
            writer.tag(11, WireType.Varint).int32(message.type);
        /* repeated rd.accounting.JournalEntry.SalesLine sales_lines = 12; */
        for (let i = 0; i < message.salesLines.length; i++)
            JournalEntry_SalesLine.internalBinaryWrite(message.salesLines[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.accounting.JournalEntry.PurchaseLine purchase_lines = 13; */
        for (let i = 0; i < message.purchaseLines.length; i++)
            JournalEntry_PurchaseLine.internalBinaryWrite(message.purchaseLines[i], writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID order_shipment_id = 14; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* string order_identifier = 15; */
        if (message.orderIdentifier !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.orderIdentifier);
        /* bool is_archived = 16; */
        if (message.isArchived !== false)
            writer.tag(16, WireType.Varint).bool(message.isArchived);
        /* rd.user.User archived_by = 17; */
        if (message.archivedBy)
            User.internalBinaryWrite(message.archivedBy, writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp archived_at = 18; */
        if (message.archivedAt)
            Timestamp.internalBinaryWrite(message.archivedAt, writer.tag(18, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntry
 */
export const JournalEntry = new JournalEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntry_SalesLine$Type extends MessageType<JournalEntry_SalesLine> {
    constructor() {
        super("rd.accounting.JournalEntry.SalesLine", [
            { no: 1, name: "account_id", kind: "message", T: () => UUID },
            { no: 2, name: "account_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "account_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "debit", kind: "message", T: () => Money },
            { no: 5, name: "credit", kind: "message", T: () => Money },
            { no: 6, name: "class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "customer", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "location_id", kind: "message", T: () => UUID },
            { no: 10, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 11, name: "internal_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] },
            { no: 12, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 13, name: "additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<JournalEntry_SalesLine>): JournalEntry_SalesLine {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountNumber = 0;
        message.accountName = "";
        message.class = "";
        message.customer = "";
        message.vendor = "";
        message.departmentIds = [];
        message.internalAccounts = [];
        message.methodIds = [];
        message.additionalFeeIds = [];
        if (value !== undefined)
            reflectionMergePartial<JournalEntry_SalesLine>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntry_SalesLine): JournalEntry_SalesLine {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID account_id */ 1:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* int32 account_number */ 2:
                    message.accountNumber = reader.int32();
                    break;
                case /* string account_name */ 3:
                    message.accountName = reader.string();
                    break;
                case /* rd.proto.money.Money debit */ 4:
                    message.debit = Money.internalBinaryRead(reader, reader.uint32(), options, message.debit);
                    break;
                case /* rd.proto.money.Money credit */ 5:
                    message.credit = Money.internalBinaryRead(reader, reader.uint32(), options, message.credit);
                    break;
                case /* string class */ 6:
                    message.class = reader.string();
                    break;
                case /* string customer */ 7:
                    message.customer = reader.string();
                    break;
                case /* string vendor */ 8:
                    message.vendor = reader.string();
                    break;
                case /* rd.proto.uuid.UUID location_id */ 9:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 10:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.coa.InternalAccount internal_accounts */ 11:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.internalAccounts.push(reader.int32());
                    else
                        message.internalAccounts.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 12:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_ids */ 13:
                    message.additionalFeeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntry_SalesLine, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID account_id = 1; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 account_number = 2; */
        if (message.accountNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.accountNumber);
        /* string account_name = 3; */
        if (message.accountName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accountName);
        /* rd.proto.money.Money debit = 4; */
        if (message.debit)
            Money.internalBinaryWrite(message.debit, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit = 5; */
        if (message.credit)
            Money.internalBinaryWrite(message.credit, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string class = 6; */
        if (message.class !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.class);
        /* string customer = 7; */
        if (message.customer !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.customer);
        /* string vendor = 8; */
        if (message.vendor !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.vendor);
        /* rd.proto.uuid.UUID location_id = 9; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 10; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.coa.InternalAccount internal_accounts = 11; */
        if (message.internalAccounts.length) {
            writer.tag(11, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.internalAccounts.length; i++)
                writer.int32(message.internalAccounts[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID method_ids = 12; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_ids = 13; */
        for (let i = 0; i < message.additionalFeeIds.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.additionalFeeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntry.SalesLine
 */
export const JournalEntry_SalesLine = new JournalEntry_SalesLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JournalEntry_PurchaseLine$Type extends MessageType<JournalEntry_PurchaseLine> {
    constructor() {
        super("rd.accounting.JournalEntry.PurchaseLine", [
            { no: 1, name: "account_id", kind: "message", T: () => UUID },
            { no: 2, name: "account_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "account_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "debit", kind: "message", T: () => Money },
            { no: 5, name: "credit", kind: "message", T: () => Money },
            { no: 6, name: "class", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "pay_to", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "invoice_date", kind: "message", T: () => Timestamp },
            { no: 11, name: "due_date", kind: "message", T: () => Timestamp },
            { no: 12, name: "order_identifier", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "order_shipment_id", kind: "message", T: () => UUID },
            { no: 14, name: "location_id", kind: "message", T: () => UUID },
            { no: 15, name: "department_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 16, name: "internal_accounts", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["rd.coa.InternalAccount", InternalAccount, "INTERNAL_ACCOUNT_"] },
            { no: 17, name: "method_ids", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UUID },
            { no: 18, name: "additional_fee_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<JournalEntry_PurchaseLine>): JournalEntry_PurchaseLine {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.accountNumber = 0;
        message.accountName = "";
        message.class = "";
        message.payTo = "";
        message.vendor = "";
        message.invoiceNumber = "";
        message.orderIdentifier = "";
        message.departmentIds = [];
        message.internalAccounts = [];
        message.methodIds = [];
        message.additionalFeeIds = [];
        if (value !== undefined)
            reflectionMergePartial<JournalEntry_PurchaseLine>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: JournalEntry_PurchaseLine): JournalEntry_PurchaseLine {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* rd.proto.uuid.UUID account_id */ 1:
                    message.accountId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.accountId);
                    break;
                case /* int32 account_number */ 2:
                    message.accountNumber = reader.int32();
                    break;
                case /* string account_name */ 3:
                    message.accountName = reader.string();
                    break;
                case /* rd.proto.money.Money debit */ 4:
                    message.debit = Money.internalBinaryRead(reader, reader.uint32(), options, message.debit);
                    break;
                case /* rd.proto.money.Money credit */ 5:
                    message.credit = Money.internalBinaryRead(reader, reader.uint32(), options, message.credit);
                    break;
                case /* string class */ 6:
                    message.class = reader.string();
                    break;
                case /* string pay_to */ 7:
                    message.payTo = reader.string();
                    break;
                case /* string vendor */ 8:
                    message.vendor = reader.string();
                    break;
                case /* string invoice_number */ 9:
                    message.invoiceNumber = reader.string();
                    break;
                case /* google.protobuf.Timestamp invoice_date */ 10:
                    message.invoiceDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.invoiceDate);
                    break;
                case /* google.protobuf.Timestamp due_date */ 11:
                    message.dueDate = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.dueDate);
                    break;
                case /* string order_identifier */ 12:
                    message.orderIdentifier = reader.string();
                    break;
                case /* rd.proto.uuid.UUID order_shipment_id */ 13:
                    message.orderShipmentId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.orderShipmentId);
                    break;
                case /* rd.proto.uuid.UUID location_id */ 14:
                    message.locationId = UUID.internalBinaryRead(reader, reader.uint32(), options, message.locationId);
                    break;
                case /* repeated rd.proto.uuid.UUID department_ids */ 15:
                    message.departmentIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated rd.coa.InternalAccount internal_accounts */ 16:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.internalAccounts.push(reader.int32());
                    else
                        message.internalAccounts.push(reader.int32());
                    break;
                case /* repeated rd.proto.uuid.UUID method_ids */ 17:
                    message.methodIds.push(UUID.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string additional_fee_ids */ 18:
                    message.additionalFeeIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: JournalEntry_PurchaseLine, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* rd.proto.uuid.UUID account_id = 1; */
        if (message.accountId)
            UUID.internalBinaryWrite(message.accountId, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 account_number = 2; */
        if (message.accountNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.accountNumber);
        /* string account_name = 3; */
        if (message.accountName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.accountName);
        /* rd.proto.money.Money debit = 4; */
        if (message.debit)
            Money.internalBinaryWrite(message.debit, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.money.Money credit = 5; */
        if (message.credit)
            Money.internalBinaryWrite(message.credit, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* string class = 6; */
        if (message.class !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.class);
        /* string pay_to = 7; */
        if (message.payTo !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.payTo);
        /* string vendor = 8; */
        if (message.vendor !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.vendor);
        /* string invoice_number = 9; */
        if (message.invoiceNumber !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.invoiceNumber);
        /* google.protobuf.Timestamp invoice_date = 10; */
        if (message.invoiceDate)
            Timestamp.internalBinaryWrite(message.invoiceDate, writer.tag(10, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp due_date = 11; */
        if (message.dueDate)
            Timestamp.internalBinaryWrite(message.dueDate, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string order_identifier = 12; */
        if (message.orderIdentifier !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderIdentifier);
        /* rd.proto.uuid.UUID order_shipment_id = 13; */
        if (message.orderShipmentId)
            UUID.internalBinaryWrite(message.orderShipmentId, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* rd.proto.uuid.UUID location_id = 14; */
        if (message.locationId)
            UUID.internalBinaryWrite(message.locationId, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.proto.uuid.UUID department_ids = 15; */
        for (let i = 0; i < message.departmentIds.length; i++)
            UUID.internalBinaryWrite(message.departmentIds[i], writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        /* repeated rd.coa.InternalAccount internal_accounts = 16; */
        if (message.internalAccounts.length) {
            writer.tag(16, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.internalAccounts.length; i++)
                writer.int32(message.internalAccounts[i]);
            writer.join();
        }
        /* repeated rd.proto.uuid.UUID method_ids = 17; */
        for (let i = 0; i < message.methodIds.length; i++)
            UUID.internalBinaryWrite(message.methodIds[i], writer.tag(17, WireType.LengthDelimited).fork(), options).join();
        /* repeated string additional_fee_ids = 18; */
        for (let i = 0; i < message.additionalFeeIds.length; i++)
            writer.tag(18, WireType.LengthDelimited).string(message.additionalFeeIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message rd.accounting.JournalEntry.PurchaseLine
 */
export const JournalEntry_PurchaseLine = new JournalEntry_PurchaseLine$Type();
